window.MockupEngine = (function() {
  // Gör externa motiv CORS-vänliga via Cloudinary fetch
  function normalizeDesignUrl(u, cloudName) {
    if (!u) return u;
    if (/^data:/i.test(u)) return u; // redan data-url
    if (!cloudName) return u;
    const isCloudinaryUpload = new RegExp('^https?://res\\.cloudinary\\.com/' + cloudName + '/image/upload/', 'i').test(u);
    if (isCloudinaryUpload) return u;
    return 'https://res.cloudinary.com/' + cloudName + '/image/fetch/' + encodeURIComponent(u);
  }


  async function render(config, designUrl, canvasId = "mockup-canvas") {
    if (!config || !config.baseImage || !designUrl) {
      console.error("MockupEngine: Saknar config/baseImage/designUrl");
      return;
    }
    const { baseImage, displacementMap, shadows, shadowOpacity, designArea, blending, highlightOverlay, designBlending, designOpacities } = config;
    try {
      const __load = (src) => new Promise((resolve, reject) => {
        if (!src) return resolve(null);
        const img = new window.Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Misslyckades ladda bild " + src));
        img.src = src;
      });

      const [baseImg, designImg, shadowImg, dispImg, highlightImg] = await Promise.all([
        __load(baseImage),
        __load(normalizeDesignUrl(designUrl, window.CLOUDINARY_CLOUD_NAME)),
        __load(shadows),
        __load(displacementMap),
        __load(highlightOverlay)
      ]);


      const canvas = document.getElementById(canvasId);
      if (!canvas) throw new Error("MockupEngine: Kunde inte hitta canvas med id " + canvasId);
      const ctx = canvas.getContext("2d");

      canvas.width = baseImg.width;
      canvas.height = baseImg.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "source-over";
      ctx.drawImage(baseImg, 0, 0);

      let mask = null;
      let autoArea = null;
      if (dispImg) {
        mask = document.createElement('canvas');
        mask.width = canvas.width;
        mask.height = canvas.height;
        const maskCtx = mask.getContext('2d');
        maskCtx.drawImage(dispImg, 0, 0, mask.width, mask.height);

        // Auto-area: hitta bbox för icke-svart mask (r-kanal > 0)
        if (config.autoArea === true) {
          try {
            const md = maskCtx.getImageData(0, 0, mask.width, mask.height).data;
            let minX = mask.width, minY = mask.height, maxX = -1, maxY = -1;
            for (let y = 0; y < mask.height; y++) {
              for (let x = 0; x < mask.width; x++) {
                const i = (y * mask.width + x) * 4;
                if (md[i] > 0) { // r-kanal
                  if (x < minX) minX = x;
                  if (y < minY) minY = y;
                  if (x > maxX) maxX = x;
                  if (y > maxY) maxY = y;
                }
              }
            }
            if (maxX >= minX && maxY >= minY) {
              autoArea = { x: minX, y: minY, width: (maxX - minX + 1), height: (maxY - minY + 1) };
            }
          } catch {}
        }
      }

      // ======== MODIFIERAD DEL: designImg, stöd för flera blend/opacities + AUTO-AREA ========
      if (designImg) {
        const blendings = Array.isArray(designBlending) && designBlending.length > 0
          ? designBlending
          : [blending || "source-over"];
        const opacities = Array.isArray(designOpacities) && designOpacities.length > 0
          ? designOpacities
          : [1.0];

        const area = autoArea || designArea;
        if (area) {
          const areaW = area.width, areaH = area.height;
          const imgW = designImg.width, imgH = designImg.height;
          const s = Math.max(areaW / imgW, areaH / imgH);
          const drawW = Math.ceil(imgW * s);
          const drawH = Math.ceil(imgH * s);
          let dx = Math.round((areaW - drawW) / 2);
          let dy = Math.round((areaH - drawH) / 2);

          const passes = Math.max(blendings.length, opacities.length);
          for (let i = 0; i < passes; i++) {
            const blendMode = blendings[i] !== undefined ? blendings[i] : blendings[blendings.length - 1];
            const opacity = opacities[i] !== undefined ? opacities[i] : opacities[opacities.length - 1];

            ctx.save();
            ctx.globalCompositeOperation = blendMode || "source-over";
            ctx.globalAlpha = (typeof opacity === "number" ? opacity : 1.0);

            if (mask) {
              const tempCanvas = document.createElement('canvas');
              tempCanvas.width = areaW;
              tempCanvas.height = areaH;
              const tempCtx = tempCanvas.getContext('2d');

              tempCtx.drawImage(designImg, 0, 0, imgW, imgH, dx, dy, drawW, drawH);

              const maskCtx = mask.getContext('2d');
              const maskData = maskCtx.getImageData(area.x, area.y, areaW, areaH);
              const tempData = tempCtx.getImageData(0, 0, areaW, areaH);
              for (let j = 0; j < maskData.data.length; j += 4) {
                const a = maskData.data[j]; // r-kanal
                tempData.data[j + 3] = Math.round(tempData.data[j + 3] * (a / 255));
              }
              tempCtx.putImageData(tempData, 0, 0);

              ctx.drawImage(tempCanvas, area.x, area.y);
            } else {
              ctx.drawImage(designImg, 0, 0, imgW, imgH, area.x + dx, area.y + dy, drawW, drawH);
            }
            ctx.restore();
          }
        }
      }
      // ======== SLUT PÅ MODIFIERAD DEL ========

      if (shadowImg) {
        ctx.save();
        ctx.globalCompositeOperation = "multiply";
        if (typeof shadowOpacity === "number" && shadowOpacity >= 0 && shadowOpacity <= 1) {
          ctx.globalAlpha = shadowOpacity;
        }
        ctx.drawImage(shadowImg, 0, 0, canvas.width, canvas.height);
        ctx.globalAlpha = 1.0;
        ctx.restore();
      }
      if (highlightImg) {
        ctx.globalCompositeOperation = "screen";
        ctx.drawImage(highlightImg, 0, 0, canvas.width, canvas.height);
      }
    } catch (err) {
      console.error("MockupEngine: Fel vid rendering:", err);
      throw err;
    }
  }

  // ===== Hjälpare: public_id/url → laddbar URL (Cloudinary eller redan full URL) =====
  function resolveSrc(entry, cloudName) {
    if (!entry) return null;
    if (typeof entry === "string") {
      if (/^https?:\/\//i.test(entry)) return entry;
      if (cloudName) {
        return "https://res.cloudinary.com/" + cloudName + "/image/upload/" + entry;
      }
      return entry;
    }
    if (entry.url) return entry.url;
    if (entry.public_id) {
      if (/^https?:\/\//i.test(entry.public_id)) return entry.public_id;
      if (cloudName) {
        return "https://res.cloudinary.com/" + cloudName + "/image/upload/" + entry.public_id;
      }
      return entry.public_id;
    }
    return null;
  }

  // =================== GLOBALA HJÄLPFUNKTIONER (placera EN gång) ===================

  // Rundad rektangel-path
  function roundRectPath(ctx, x, y, w, h, r) {
    const rr = Math.max(0, Math.min(r || 0, Math.min(w, h) / 2));
    ctx.beginPath();
    ctx.moveTo(x + rr, y);
    ctx.arcTo(x + w, y, x + w, y + h, rr);
    ctx.arcTo(x + w, y + h, x, y + h, rr);
    ctx.arcTo(x, y + h, x, y, rr);
    ctx.arcTo(x, y, x + w, y, rr);
    ctx.closePath();
  }
// --- helper: räkna ratio från "85:55" eller siffra ---
function _ratioFrom(val, fallback=1){
  if (typeof val === 'number' && isFinite(val) && val>0) return val;
  if (typeof val === 'string') {
    const m = val.match(/^\s*(\d+(?:\.\d+)?)\s*:\s*(\d+(?:\.\d+)?)\s*$/);
    if (m) {
      const w = parseFloat(m[1]), h = parseFloat(m[2]);
      if (h>0) return w/h;
    }
    const n = parseFloat(val);
    if (isFinite(n) && n>0) return n;
  }
  return fallback;
}

function drawSmartCardPlacement(ctx, designImg, placement) {
  const canvas = ctx.canvas;
  const r   = placement.rect || {};
  const box = placement.box  || {};
  const smart = placement.smart || {};

  const pad    = Number(box.padding || 0);
  const radius = Number(box.borderRadius || 0);
  const bg     = (box.backgroundColor == null ? "transparent" : box.backgroundColor);

  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  const bw     = Number(box.borderWidth || 0);
  const bc     = box.borderColor || "#000";

  // 1) Bestäm mål-ratio (kvadrat vs 85:55) utifrån input-aspect
  const srcW = designImg.width, srcH = designImg.height;
  const srcAR = (srcH>0) ? (srcW/srcH) : 1;

  const thr = Math.max(0, Number(smart.squareAspectThreshold ?? 0.06)); // ±6%
  const isSquareish = Math.abs(srcAR - 1) <= thr;

  const rectAR   = _ratioFrom(smart.rectAspect   ?? "85:55", 85/55);
  const squareAR = _ratioFrom(smart.squareAspect ?? "1:1"  , 1);

  const targetAR = isSquareish ? squareAR : rectAR;

  // 2) Boxens maxmått
  const refMaxW = (typeof r.maxWidth  === 'number' && r.maxWidth  > 0) ? r.maxWidth  : (r.w || r.width  || canvas.width);
  const refMaxH = (typeof r.maxHeight === 'number' && r.maxHeight > 0) ? r.maxHeight : (r.h || r.height || canvas.height);

  // 3) Räkna ut "kortets" tile-storlek (innanför padding) så att det matchar targetAR
  const innerMaxW = Math.max(1, refMaxW - pad*2);
  const innerMaxH = Math.max(1, refMaxH - pad*2);

  // Vi vill få ut tileW x tileH med tileW/tileH = targetAR och så stort som får plats
  let tileW = innerMaxW;
  let tileH = Math.round(tileW / targetAR);
  if (tileH > innerMaxH) {
    tileH = innerMaxH;
    tileW = Math.round(tileH * targetAR);
  }

  // 4) Själva boxens storlek runt tile
  const boxW = tileW + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);
  const boxH = tileH + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);

  // 5) Placera box på canvas (center default)
  let bx, by;
  if (r.center === true || r.x === 'center' || r.y === 'center') {
    bx = Math.round((canvas.width  - boxW) / 2);
    by = Math.round((canvas.height - boxH) / 2);
  } else {
    const boundsW = Math.max(1, Number(r.w || r.width  || canvas.width));
    const boundsH = Math.max(1, Number(r.h || r.height || canvas.height));
    bx = (typeof r.x === 'number') ? r.x : Math.round((canvas.width  - boundsW) / 2);
    by = (typeof r.y === 'number') ? r.y : Math.round((canvas.height - boundsH) / 2);
    if (typeof r.cx === 'number') bx = Math.round(r.cx - boxW / 2);
    if (typeof r.cy === 'number') by = Math.round(r.cy - boxH / 2);
  }

  // 🔹 bakgrund + skugga för hela boxen
  ctx.save();
  roundRectPath(ctx, bx, by, boxW, boxH, radius);
  ctx.shadowColor   = shColor;
  ctx.shadowBlur    = shBlur;
  ctx.shadowOffsetX = shOX;
  ctx.shadowOffsetY = shOY;
  ctx.fillStyle     = (bg && bg !== "transparent") ? bg : "rgba(0,0,0,0)";
  ctx.fill();
  ctx.restore();

  // 7) Klipp till kortets rundade hörn och rita motivet "contain" i tile
  const fit   = String(placement.design?.fit || 'contain').toLowerCase();
  const allow = !(placement.design && placement.design.allowUpscale === false);

  const ix = bx + pad;
  const iy = by + pad;

  // Klippning
  ctx.save();
  roundRectPath(ctx, ix, iy, tileW, tileH, radius);
  ctx.clip();

  // Skala motivet så att det "contain":ar i kortet
  const sx = tileW / srcW, sy = tileH / srcH;
  let s = (fit === 'cover') ? Math.max(sx, sy) : Math.min(sx, sy);
  if (!allow) s = Math.min(1, s);

  const drawW = Math.max(1, Math.round(srcW * s));
  const drawH = Math.max(1, Math.round(srcH * s));
  const dx = ix + Math.round((tileW - drawW) / 2);
  const dy = iy + Math.round((tileH - drawH) / 2);

  ctx.globalCompositeOperation = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  ctx.globalAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;
  ctx.drawImage(designImg, 0, 0, srcW, srcH, dx, dy, drawW, drawH);
  ctx.restore();

  // 8) Tunn ram runt kortet om satt
  if (bw > 0) {
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.lineWidth = bw;
    ctx.strokeStyle = bc;
    ctx.shadowColor = "transparent";
    ctx.stroke();
    ctx.restore();
  }
}


  // Auto-centrerad rect (kan vara överflödig i din setup men kvar för kompatibilitet)
  function resolvePlacementRect(r, canvas) {
    const w = Math.max(1, Number(r.w || r.width || canvas.width));
    const h = Math.max(1, Number(r.h || r.height || canvas.height));

    let x = (r.center === true || r.x === 'center')
      ? Math.round((canvas.width  - w) / 2)
      : (typeof r.x === 'number' ? r.x : 0);

    let y = (r.center === true || r.y === 'center')
      ? Math.round((canvas.height - h) / 2)
      : (typeof r.y === 'number' ? r.y : 0);

    if (typeof r.cx === 'number') x = Math.round(r.cx - w / 2);
    if (typeof r.cy === 'number') y = Math.round(r.cy - h / 2);

    return { x, y, w, h };
  }

  // Botten-medveten placering för en box med given boxW/boxH
  function resolveRectBottomAware(r, canvas, boxW, boxH) {
    // Horisontellt
    let bx;
    if (typeof r.cx === 'number') {
      bx = Math.round(r.cx - boxW / 2);
    } else if (r.x === 'center' || r.center === true) {
      bx = Math.round((canvas.width - boxW) / 2);
    } else if (typeof r.x === 'number') {
      bx = r.x;
    } else {
      const refW = Math.max(1, Number(r.w || r.width || canvas.width));
      bx = Math.round((canvas.width - refW) / 2);
    }

    // Vertikalt
    let by;
    if (typeof r.bottom === 'number' || r.attach === 'bottom') {
      const bottom = (typeof r.bottom === 'number') ? r.bottom : 0;
      by = canvas.height - bottom - boxH;
    } else if (typeof r.cy === 'number') {
      by = Math.round(r.cy - boxH / 2);
    } else if (r.y === 'center' || r.center === true) {
      by = Math.round((canvas.height - boxH) / 2);
    } else if (typeof r.y === 'number') {
      by = r.y;
    } else {
      const refH = Math.max(1, Number(r.h || r.height || canvas.height));
      by = Math.round((canvas.height - refH) / 2);
    }

    return { bx, by };
  }

  // Tolka aspect ratio (t.ex. "3:4" eller 1.25)
  function parseAspectRatio(val, fallbackRatio = 1) {
    if (typeof val === "number" && isFinite(val) && val > 0) return val;
    if (typeof val === "string") {
      const m = val.match(/^\s*(\d+(?:\.\d+)?)\s*:\s*(\d+(?:\.\d+)?)\s*$/);
      if (m) {
        const w = parseFloat(m[1]), h = parseFloat(m[2]);
        if (h > 0) return w / h;
      }
      const num = parseFloat(val);
      if (isFinite(num) && num > 0) return num;
    }
    return fallbackRatio;
  }
function drawAlphaBorderFromImage(ctx, srcCanvas, dx, dy, border = {}) {
  const color   = border.color   || "#000000";
  const blur    = Number(border.blur || 0);
  const offX    = Number(border.offsetX || 0);
  const offY    = Number(border.offsetY || 0);
  const opacity = (typeof border.opacity === "number" ? border.opacity : 1);
  const width   = Number(border.width || 0);

  const w = srcCanvas.width;
  const h = srcCanvas.height;

  // Ge ringen plats att andas utanför formen.
  // Pad ~ 2*blur + 2*width + liten marginal så skugga inte klipps.
  const pad = Math.max(2, Math.ceil(blur * 2 + width * 2 + 4));

  const ring = document.createElement('canvas');
  ring.width  = w + pad * 2;
  ring.height = h + pad * 2;
  const rctx = ring.getContext('2d');

  rctx.save();
  rctx.globalAlpha = opacity;
  rctx.shadowColor   = color;
  rctx.shadowBlur    = blur;
  rctx.shadowOffsetX = offX;
  rctx.shadowOffsetY = offY;
  rctx.globalCompositeOperation = "source-over";
  // Rita källmasken med padding-offset så skuggan får utrymme utåt
  rctx.drawImage(srcCanvas, pad, pad);
  rctx.restore();

  // Skär bort fyllningen (lämna bara ringen)
  rctx.save();
  rctx.shadowColor = "transparent";
  rctx.shadowBlur = 0; rctx.shadowOffsetX = 0; rctx.shadowOffsetY = 0;
  rctx.globalCompositeOperation = "destination-out";
  rctx.drawImage(srcCanvas, pad, pad);
  rctx.restore();

  // Extra "spread" inåt/utåt via width
  if (width > 0) {
    const shrink = document.createElement('canvas');
    shrink.width  = w;
    shrink.height = h;
    const sctx = shrink.getContext('2d');
    const inset = Math.min(width, Math.floor(Math.min(w, h) / 4));
    sctx.drawImage(
      srcCanvas,
      inset, inset, w - inset * 2, h - inset * 2,
      inset, inset, w - inset * 2, h - inset * 2
    );
    rctx.save();
    rctx.globalCompositeOperation = "source-over";
    rctx.shadowColor   = color;
    rctx.shadowBlur    = blur;
    rctx.shadowOffsetX = offX;
    rctx.shadowOffsetY = offY;
    rctx.drawImage(shrink, pad, pad); // samma offset
    rctx.globalCompositeOperation = "destination-out";
    rctx.drawImage(shrink, pad, pad);
    rctx.restore();
  }

  // Rita tillbaka med kompenserad offset
  ctx.save();
  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
  ctx.drawImage(ring, dx - pad, dy - pad);
  ctx.restore();
}


 // --- FORM-CLIP HELPERS ---
function shapeClipPath(ctx, shape, x, y, w, h) {
  const type = (shape && shape.type) ? String(shape.type).toLowerCase() : "rect";
  const cr = Math.max(0, Number(shape && shape.cornerRadius || 0));

  if (type === "circle") {
    const d = Math.min(w, h);
    const cx = x + w / 2, cy = y + h / 2, r = d / 2;
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.closePath();
    return;
  }
  if (type === "ellipse") {
    const cx = x + w / 2, cy = y + h / 2;
    ctx.beginPath();
    ctx.ellipse(cx, cy, w / 2, h / 2, 0, 0, Math.PI * 2);
    ctx.closePath();
    return;
  }
  if (type === "rounded") {
    roundRectPath(ctx, x, y, w, h, cr);
    return;
  }
  // default: rektangel
  ctx.beginPath();
  ctx.rect(x, y, w, h);
  ctx.closePath();
}

function drawDesignIntoTileClipped(ctx, designImg, tileX, tileY, tileW, tileH, shape, fitMode = "cover", allowUpscale = true) {
  if (tileW <= 0 || tileH <= 0) return;

  // 1) Klipp enligt form
  ctx.save();
  shapeClipPath(ctx, shape, tileX, tileY, tileW, tileH);
  ctx.clip();

  // 2) Skala motivet för att fylla tile-rektangeln (croppas av formen ovan)
  const srcW = designImg.width, srcH = designImg.height;
  const sx = tileW / srcW, sy = tileH / srcH;
  let s = (String(fitMode).toLowerCase() === "contain") ? Math.min(sx, sy) : Math.max(sx, sy);
  if (!allowUpscale) s = Math.min(1, s);

  const drawW = Math.max(1, Math.round(srcW * s));
  const drawH = Math.max(1, Math.round(srcH * s));
  const dx = tileX + Math.round((tileW - drawW) / 2);
  const dy = tileY + Math.round((tileH - drawH) / 2);

  ctx.drawImage(designImg, 0, 0, srcW, srcH, dx, dy, drawW, drawH);
  ctx.restore();
}


function drawRepeatedDesignIntoArea(ctx, designImg, area, maskData, opts = {}) {
  const { rotate90 = false, tileW, tileH, border } = opts;

  // Skapa tile-canvas
  let tileCanvas = document.createElement('canvas');
  let tW = tileW, tH = tileH;
  if (rotate90) {
    tileCanvas.width = tH;
    tileCanvas.height = tW;
    const rctx = tileCanvas.getContext('2d');
    rctx.translate(tileCanvas.width / 2, tileCanvas.height / 2);
    rctx.rotate(Math.PI / 2);
    rctx.drawImage(designImg, -tileW / 2, -tileH / 2, tileW, tileH);
    tW = tileCanvas.width; tH = tileCanvas.height;
  } else {
    tileCanvas.width = tW; tileCanvas.height = tH;
    tileCanvas.getContext('2d').drawImage(designImg, 0, 0, tileW, tileH);
  }

  // Fyll area i offscreen (STRÄCK vertikalt till full höjd, repetera ENDAST horisontellt)
  const areaCanvas = document.createElement('canvas');
  areaCanvas.width = area.width;
  areaCanvas.height = area.height;
  const actx = areaCanvas.getContext('2d');

  // Skala brickan så att den täcker hela höjden
  const scaleY = area.height / tH;
  const stripeW = Math.max(1, Math.round(tW * scaleY));
  const stripeH = area.height;

  const stripeCanvas = document.createElement('canvas');
  stripeCanvas.width = stripeW;
  stripeCanvas.height = stripeH;
  const sctx = stripeCanvas.getContext('2d');
  sctx.drawImage(tileCanvas, 0, 0, tW, tH, 0, 0, stripeW, stripeH);

  // Repetera endast i X-led
  for (let x = 0; x < area.width; x += stripeW) {
    actx.drawImage(stripeCanvas, x, 0);
  }

  // Applicera mask (om finns) – bevarar alfaytan för kanten
  if (maskData) {
    const td = actx.getImageData(0, 0, area.width, area.height);
    for (let j = 0; j < maskData.data.length; j += 4) {
      const a = maskData.data[j];
      td.data[j + 3] = Math.round(td.data[j + 3] * (a / 255));
    }
    actx.putImageData(td, 0, 0);
  }

  // Rita mot huvudduk
  ctx.drawImage(areaCanvas, area.x, area.y);

  // Border som följer alfa (hela repeterade ytan)
  if (border && (border.width > 0 || border.blur > 0)) {
    drawAlphaBorderFromImage(ctx, areaCanvas, area.x, area.y, border);
  }
}


// =================== RENDER FRÅN TEMPLATE ===================
async function renderFromTemplate(item, designUrl, canvasId = "mockup-canvas", opts = {}) {
  if (!item) throw new Error("renderFromTemplate: saknar item");
  if (!designUrl) throw new Error("renderFromTemplate: saknar designUrl");

  const cloudName = opts.cloudName || window.CLOUDINARY_CLOUD_NAME || null;
  const placements = Array.isArray(item.placements) ? item.placements : [];
  if (!placements.length) throw new Error("renderFromTemplate: saknar placements[] i item id=" + item.id);

  const __load = (src) => new Promise((resolve, reject) => {
    if (!src) return resolve(null);
    const img = new window.Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Misslyckades ladda bild " + src));
    img.src = src;
  });

  async function ensureUploadToCloudinary(url, cloudName, preset) {
    if (/^https?:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//i.test(url)) return url;
    const KEY = `pressify.design.uploaded.v1::${cloudName}`;
    const map = JSON.parse(localStorage.getItem(KEY) || '{}');
    if (map[url]) return map[url];

    const fd = new FormData();
    fd.append('file', url);
    fd.append('upload_preset', window.CLOUDINARY_UNSIGNED_PRESET || preset || 'pitchprint_unsigned');

    const endpoint = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
    const res = await fetch(endpoint, { method: 'POST', body: fd });
    const json = await res.json();
    if (json.secure_url) {
      map[url] = json.secure_url;
      try { localStorage.setItem(KEY, JSON.stringify(map)); } catch {}
      return json.secure_url;
    }
    throw new Error('Cloudinary upload misslyckades: ' + (json.error && json.error.message ? json.error.message : 'okänt fel'));
  }

  // Canvas/ctx
  const canvas = document.getElementById(canvasId);
  if (!canvas) throw new Error("MockupEngine: Kunde inte hitta canvas med id " + canvasId);
  const ctx = canvas.getContext("2d");

  // Resurser
  const baseImage = resolveSrc(item.base, cloudName);
  const highlightOverlay = (item.highlights && item.highlights.length) ? resolveSrc(item.highlights[0], cloudName) : null;
  const shadowsSrc = (item.shadows && item.shadows.length) ? resolveSrc(item.shadows[0], cloudName) : null;
  const shadowOpacity = (item.shadows && item.shadows.length && typeof item.shadows[0].opacity === "number") ? item.shadows[0].opacity : 1.0;

  // Rita bas
  const baseImg = await __load(baseImage);
  canvas.width = baseImg.width;
  canvas.height = baseImg.height;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
  ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);

  // Design
  const designSrc = await ensureUploadToCloudinary(designUrl, cloudName, opts.uploadPreset);
  const designImg = await __load(designSrc);

  // Mask-bbox-hjälpare
  function bboxFromMask(maskImg) {
    const mCanvas = document.createElement('canvas');
    mCanvas.width = canvas.width;
    mCanvas.height = canvas.height;
    const mCtx = mCanvas.getContext('2d');
    mCtx.drawImage(maskImg, 0, 0, canvas.width, canvas.height);
    const data = mCtx.getImageData(0, 0, canvas.width, canvas.height).data;

    let minX = canvas.width, minY = canvas.height, maxX = -1, maxY = -1;
    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const i = (y * canvas.width + x) * 4;
        if (data[i] > 0) { // r > 0
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX >= minX && maxY >= minY) {
      return { x: minX, y: minY, width: (maxX - minX + 1), height: (maxY - minY + 1), mCtx };
    }
    return { x: 0, y: 0, width: canvas.width, height: canvas.height, mCtx };
  }
function drawBoxPlacement(ctx, designImg, area, placement, opts = {}) {
  const canvas = ctx.canvas;
  const box = placement.box || {};
  const r   = placement.rect || {};

  const pad    = Number(box.padding || 0);
  const radius = Number(box.borderRadius || 0);
  const bg     = (box.backgroundColor == null ? "transparent" : box.backgroundColor);
  const bw     = Number(box.borderWidth || 0);
  const bc     = box.borderColor || "#000";

  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  const motifShadow = (opts.motifShadow !== undefined)
    ? !!opts.motifShadow
    : !!(placement.placementOptions && placement.placementOptions.motifShadow);

  const enableMinRect = (opts.enableMinRect !== undefined)
    ? !!opts.enableMinRect
    : !!(placement.placementOptions && placement.placementOptions.enableMinRect);

  const srcW = designImg.width, srcH = designImg.height;

  // --- Max-dimensioner för motivet (inuti padding) ---
  const innerMaxW = (typeof r.maxWidth  === 'number' && r.maxWidth  > 0) ? Math.max(1, r.maxWidth  - pad * 2) : Infinity;
  const innerMaxH = (typeof r.maxHeight === 'number' && r.maxHeight > 0) ? Math.max(1, r.maxHeight - pad * 2) : Infinity;

  // --- Min-dimensioner (bara när enableMinRect = true) ---
  const innerMinW = (enableMinRect && typeof r.minWidth  === 'number' && r.minWidth  > 0) ? Math.max(1, r.minWidth  - pad * 2) : 0;
  const innerMinH = (enableMinRect && typeof r.minHeight === 'number' && r.minHeight > 0) ? Math.max(1, r.minHeight - pad * 2) : 0;

  // --- Skala för att hålla sig inom max (contain) ---
  let sFit;
  {
    const sw = (innerMaxW !== Infinity) ? (innerMaxW / srcW) : Infinity;
    const sh = (innerMaxH !== Infinity) ? (innerMaxH / srcH) : Infinity;
    sFit = Math.min(sw, sh);
    if (!isFinite(sFit) || sFit <= 0) sFit = 1;
  }

  if (enableMinRect && (innerMinW > 0 || innerMinH > 0)) {
    const needW = innerMinW > 0 ? (innerMinW / srcW) : 0;
    const needH = innerMinH > 0 ? (innerMinH / srcH) : 0;
    const sMin  = Math.max(needW || 0, needH || 0);
    if (sMin > 0) sFit = Math.max(sFit, sMin);
  } else if (placement.design && placement.design.allowUpscale === false) {
    sFit = Math.min(1, sFit);
  }

  const drawW = Math.max(1, Math.round(srcW * sFit));
  const drawH = Math.max(1, Math.round(srcH * sFit));

  // --- Boxens yttre storlek (inkl padding & ev. border) ---
  const boxW = drawW + pad * 2 + (bw > 0 ? Math.ceil(bw) : 0);
  const boxH = drawH + pad * 2 + (bw > 0 ? Math.ceil(bw) : 0);

  // --- Placering av boxen på canvas ---
  let bx, by;
  if (r.center === true || r.x === 'center' || r.y === 'center') {
    bx = Math.round((canvas.width  - boxW) / 2);
    by = Math.round((canvas.height - boxH) / 2);
  } else {
    const boundsW = Math.max(1, Number(r.w || r.width  || canvas.width));
    const boundsH = Math.max(1, Number(r.h || r.height || canvas.height));
    bx = (typeof r.x === 'number') ? r.x : Math.round((canvas.width  - boundsW) / 2);
    by = (typeof r.y === 'number') ? r.y : Math.round((canvas.height - boundsH) / 2);
    if (typeof r.cx === 'number') bx = Math.round(r.cx - boxW / 2);
    if (typeof r.cy === 'number') by = Math.round(r.cy - boxH / 2);
  }

  // === ROTATION ===
  const dcfg   = placement.design || {};
  const fit    = String(dcfg.fit || 'contain').toLowerCase();
  const allow  = !(dcfg && dcfg.allowUpscale === false);

  let rotDeg = Number(dcfg.rotate != null ? dcfg.rotate : dcfg.rotate_deg != null ? dcfg.rotate_deg : 0);

  const boxInnerW = Math.max(1, boxW - pad * 2);
  const boxInnerH = Math.max(1, boxH - pad * 2);
  const imgIsLandscape = srcW > srcH;
  const boxIsPortrait  = boxInnerH > boxInnerW;

  if (dcfg.rotate_if_landscape === true && imgIsLandscape) rotDeg = rotDeg || 90;
  if (dcfg.rotate_if_landscape_in_portrait === true && boxIsPortrait && imgIsLandscape) rotDeg = rotDeg || 90;

  const rotRad = rotDeg * Math.PI / 180;

  // Rotationscentrum = boxens centrum (hela gruppen ska rotera)
  const cx = bx + boxW / 2;
  const cy = by + boxH / 2;

  // === BYGG MOTIV-MASK (PNG-alfa, EJ roterad här) ===
  const motifMaskCanvas = document.createElement('canvas');
  motifMaskCanvas.width = boxW;
  motifMaskCanvas.height = boxH;
  (function buildMotifMask() {
    const mctx2 = motifMaskCanvas.getContext('2d');
    // Klipp till boxens form (rundade hörn)
    roundRectPath(mctx2, 0, 0, boxW, boxH, radius);
    mctx2.clip();

    // Centrera motivet i inner-ytan (ingen rotation i masken – gruppen roteras senare)
    const innerW2 = Math.max(1, boxW - pad * 2);
    const innerH2 = Math.max(1, boxH - pad * 2);
    const dx2 = pad + Math.round((innerW2 - drawW) / 2);
    const dy2 = pad + Math.round((innerH2 - drawH) / 2);

    mctx2.drawImage(designImg, 0, 0, srcW, srcH, dx2, dy2, drawW, drawH);
  })();

  // === BYGG HELA BOXEN OFFSCREEN SOM EN GRUPP ===
  const group = document.createElement('canvas');
  group.width  = boxW;
  group.height = boxH;
  const gctx = group.getContext('2d');

  // 1) Bakgrund (utan skugga – skuggan dras i roterad main-kontext)
  gctx.save();
  roundRectPath(gctx, 0, 0, boxW, boxH, radius);
  gctx.fillStyle = (bg && bg !== "transparent") ? bg : "rgba(0,0,0,0)";
  gctx.fill();
  gctx.restore();

  // 2) Skugga kring motivet (alfa) inne i gruppen om begärt
  if (motifShadow) {
    gctx.save();
    gctx.shadowColor   = shColor;
    gctx.shadowBlur    = shBlur;
    gctx.shadowOffsetX = shOX;
    gctx.shadowOffsetY = shOY;
    gctx.drawImage(motifMaskCanvas, 0, 0);
    gctx.restore();
  }

  // 3) Rita själva motivet via mask (i gruppen)
  gctx.save();
  gctx.globalCompositeOperation = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  gctx.globalAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;
  gctx.drawImage(motifMaskCanvas, 0, 0);
  gctx.restore();

  // 4) Laminat som följer motivets alfa (i gruppen)
  const wantLaminate = !!(placement.placementOptions && placement.placementOptions.laminate);
  if (wantLaminate) {
    const laminateAlpha = (typeof placement.placementOptions.laminateAlpha === "number")
      ? placement.placementOptions.laminateAlpha
      : 0.33;
    const lamSrc = (placement.placementOptions && placement.placementOptions.laminateSource) || "motif";

    let lamMask = motifMaskCanvas; // default: motiv-alfa
    if (lamSrc === "shape" || lamSrc === "box") {
      const shapeMask = document.createElement('canvas');
      shapeMask.width  = boxW;
      shapeMask.height = boxH;
      const mctx = shapeMask.getContext('2d');
      roundRectPath(mctx, 0, 0, boxW, boxH, radius);
      mctx.fillStyle = "#000"; // solid form
      mctx.fill();
      lamMask = shapeMask;
    }

    const lam = document.createElement('canvas');
    lam.width = boxW;
    lam.height = boxH;
    const lctx = lam.getContext('2d');

    const g = lctx.createLinearGradient(0, 0, 0, boxH);
    g.addColorStop(0.00, "rgba(255,255,255,0.22)");
    g.addColorStop(0.35, "rgba(255,255,255,0.10)");
    g.addColorStop(1.00, "rgba(255,255,255,0.00)");
    lctx.fillStyle = g;
    lctx.fillRect(0, 0, boxW, boxH);

    lctx.globalCompositeOperation = "destination-in";
    lctx.drawImage(lamMask, 0, 0);

    // Lägg på laminatet inom boxens rundade hörn
    gctx.save();
    roundRectPath(gctx, 0, 0, boxW, boxH, radius);
    gctx.clip();
    gctx.globalCompositeOperation = "screen";
    gctx.globalAlpha = laminateAlpha;
    gctx.drawImage(lam, 0, 0);
    gctx.restore();
  }

  // 5) Tunn ram runt boxen (i gruppen)
  if (bw > 0) {
    gctx.save();
    roundRectPath(gctx, 0, 0, boxW, boxH, radius);
    gctx.lineWidth = bw;
    gctx.strokeStyle = bc;
    gctx.shadowColor = "transparent";
    gctx.stroke();
    gctx.restore();
  }

  // === DRA ALLT ROTERAT I MAIN-KONTEXTEN ===
  ctx.save();
  // 5a) Roterad box-skugga (hela boxens wrapper) om vi INTE använder motifShadow som ersättning
  if (!motifShadow && (shColor && shColor !== "transparent") && (shBlur > 0 || shOX !== 0 || shOY !== 0)) {
    ctx.translate(cx, cy);
    ctx.rotate(rotRad);
    ctx.translate(-cx, -cy);

    // Rita en temporär fylld form för skugga och slå sedan ut fyllningen
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.shadowColor   = shColor;
    ctx.shadowBlur    = shBlur;
    ctx.shadowOffsetX = shOX;
    ctx.shadowOffsetY = shOY;
    ctx.fillStyle = "#000";
    ctx.fill();

    ctx.globalCompositeOperation = "destination-out";
    ctx.shadowColor = "transparent";
    ctx.shadowBlur = 0; ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0;
    ctx.fillStyle = "#000";
    ctx.fill();
    ctx.restore();

    // Återställ för gruppens ritning
    ctx.setTransform(1,0,0,1,0,0);
  }

  // 5b) Roterad grupp (bakgrund + motiv + laminat + border)
  ctx.translate(cx, cy);
  ctx.rotate(rotRad);
  ctx.translate(-cx, -cy);
  ctx.drawImage(group, bx, by);
  ctx.restore();

  // === RETURNERA METADATA (inkl. transform för border/highlight efteråt) ===
  return {
    bx, by, boxW, boxH, radius,
    motifMaskCanvas,
    transform: (rotDeg !== 0) ? { rotateDeg: rotDeg, cx, cy } : undefined
  };
}





function drawRollTwoYPlacement(ctx, designImg, placement) {
  const out = [];
  const canvas = ctx.canvas;
  const box = placement.box || {};
  const r   = placement.rect || {};

  const pad    = Number(box.padding || 0);
  const boxBg  = (box.backgroundColor == null ? "transparent" : box.backgroundColor);
  const motifBW = Number(box.borderWidth || 0);
  const motifBC = box.borderColor || "#000";
  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  const gapPx = Math.max(0, Number(placement.gapY ?? (placement.gap && placement.gap.y) ?? 0));

  // --- width is fixed; height can be auto from visibleCountY ---
  const boxW_input = Math.max(1, Number(r.w || r.width));
  let   boxH_input = Number(r.h || r.height);
  const wantAutoH  = (typeof placement.visibleCountY === "number" && placement.visibleCountY > 0);

  // We need tile size to compute auto height
  const imgW = designImg.width, imgH = designImg.height;

  // label shape / ratio
  const shapeFromPlacement = placement.shape || null;
  const tileCornerRadius = Number(box.borderRadius || 0);
  const tileShape = shapeFromPlacement || (tileCornerRadius > 0
    ? { type: "rounded", cornerRadius: tileCornerRadius }
    : null);

  let ratio;
  if (tileShape && String(tileShape.type || "").toLowerCase() === "circle") {
    ratio = 1;
  } else if (tileShape && (tileShape.ratio || tileShape.aspect)) {
    ratio = parseAspectRatio(tileShape.ratio || tileShape.aspect, imgW / imgH);
  } else if (typeof placement.aspectRatio !== "undefined") {
    ratio = parseAspectRatio(placement.aspectRatio, imgW / imgH);
  } else {
    ratio = imgW / imgH;
  }

  const innerW = Math.max(1, boxW_input - pad*2);
  const tileW  = innerW;
  const tileH  = Math.max(1, Math.round(tileW / ratio));

  // Auto height so ~visibleCountY tiles are visible (gaps only between fully visible tiles)
  if (wantAutoH) {
    const fullGaps = Math.max(0, Math.ceil(placement.visibleCountY) - 1);
    const visibleH = placement.visibleCountY * tileH + fullGaps * gapPx;
    boxH_input = pad*2 + Math.round(visibleH);
  }

  const boxW = boxW_input;
  const boxH = Math.max(1, isFinite(boxH_input) ? boxH_input : (pad*2 + tileH*2 + gapPx)); // fallback ≈ 2 tiles

  // Where to place the roll on the main canvas (supports bottom attach/center/cx,cy)
  const { bx, by } = resolveRectBottomAware(r, canvas, boxW, boxH);

  // 🛠 Skugg-padding så blur/offset inte klipps i offscreen-canvas
  const shadowPad = Math.max(2, Math.ceil(shBlur * 2 + Math.abs(shOX) + Math.abs(shOY) + 4));

  // --- Build the roll offscreen (med padding) ---
  const roll = document.createElement('canvas');
  roll.width  = boxW + shadowPad * 2;
  roll.height = boxH + shadowPad * 2;
  const rctx = roll.getContext('2d');

  // Bg + shadow for the whole roll block (ritas förskjutet med padding)
  rctx.save();
  rctx.beginPath(); rctx.rect(shadowPad, shadowPad, boxW, boxH); rctx.closePath();
  rctx.shadowColor   = shColor;
  rctx.shadowBlur    = shBlur;
  rctx.shadowOffsetX = shOX;
  rctx.shadowOffsetY = shOY;
  rctx.fillStyle = (boxBg && boxBg !== "transparent") ? boxBg : "rgba(0,0,0,0)";
  rctx.fill();
  rctx.restore();

  // Clip contents to the roll box (samma offset som ovan)
  rctx.save();
  rctx.beginPath(); rctx.rect(shadowPad, shadowPad, boxW, boxH); rctx.closePath();
  rctx.clip();

  // Inner drawing rect (förskjutet inuti den paddade rullen)
  const ix = pad + shadowPad;
  const iy = pad + shadowPad;
  const tileX = ix;

  const fitMode = (placement.design && placement.design.fit) || "cover";
  const allowUpscale = !(placement.design && placement.design.allowUpscale === false);

  rctx.globalCompositeOperation = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  rctx.globalAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;

  const count = Math.max(1, Number(placement.repeatCount || 2));

  const collect = (tileY) => {
    const tileCanvas = document.createElement('canvas');
    tileCanvas.width = tileW;
    tileCanvas.height = tileH;
    const tctx = tileCanvas.getContext('2d');

    shapeClipPath(tctx, tileShape, 0, 0, tileW, tileH);
    tctx.clip();

    const sx = tileW / imgW, sy = tileH / imgH;
    let s = (String(fitMode).toLowerCase() === "contain") ? Math.min(sx, sy) : Math.max(sx, sy);
    if (!allowUpscale) s = Math.min(1, s);

    const drawW = Math.max(1, Math.round(imgW * s));
    const drawH = Math.max(1, Math.round(imgH * s));
    const dx = Math.round((tileW - drawW) / 2);
    const dy = Math.round((tileH - drawH) / 2);

    tctx.drawImage(designImg, 0, 0, imgW, imgH, dx, dy, drawW, drawH);

    // Onto the roll (kompenserat för shadowPad)
    rctx.drawImage(tileCanvas, tileX, tileY);

    if (motifBW > 0) {
      rctx.save();
      shapeClipPath(rctx, tileShape, tileX, tileY, tileW, tileH);
      rctx.lineWidth = motifBW;
      rctx.strokeStyle = motifBC;
      rctx.stroke();
      rctx.restore();
    }

    // Collect mask info for highlight/border
    const pBorder = placement.printAreaBorder || {};
    const srcPref = (typeof pBorder.source === "string") ? pBorder.source.toLowerCase() : null;
    const wantShapeMask = srcPref ? (srcPref === "shape") : !!placement.shape;

    let maskForBorder = tileCanvas;
    let formRadius = 0;
    if (wantShapeMask) {
      const shapeMask = document.createElement('canvas');
      shapeMask.width = tileW; shapeMask.height = tileH;
      const mctx = shapeMask.getContext('2d');
      shapeClipPath(mctx, tileShape, 0, 0, tileW, tileH);
      mctx.clip();
      mctx.fillStyle = "#000";
      mctx.fillRect(0, 0, tileW, tileH);
      maskForBorder = shapeMask;
      formRadius = (tileShape && String(tileShape.type || "").toLowerCase() === "rounded")
        ? Number(tileShape.cornerRadius || 0) : 0;
    }

    const rotateDeg = Number(placement.postRotate || 0);
    const transform = (rotateDeg !== 0)
      ? { rotateDeg, cx: bx + boxW / 2, cy: by + boxH / 2 }
      : null;

    // 🧭 Viktigt: rapportera absoluta koordinater på huvud-canvasen
    out.push({
      bx: bx - shadowPad + tileX,
      by: by - shadowPad + tileY,
      boxW: tileW,
      boxH: tileH,
      radius: formRadius,
      motifMaskCanvas: maskForBorder,
      placement,
      ...(transform ? { transform } : {})
    });
  };

  let y = iy;
  for (let i = 0; i < count; i++) {
    collect(y);
    y += tileH + gapPx;
    if (y - iy > boxH + 10) break; // overflow is clipped → size is locked
  }
  rctx.restore();

  // Place/rotate the whole roll block (kompensera för padding)
  const rotateDeg = Number(placement.postRotate || 0);
  const cx = bx + boxW / 2, cy = by + boxH / 2;

  ctx.save();
  if (rotateDeg !== 0) {
    const rad = rotateDeg * Math.PI / 180;
    ctx.translate(cx, cy);
    ctx.rotate(rad);
    ctx.translate(-cx, -cy);
  }
  ctx.drawImage(roll, bx - shadowPad, by - shadowPad);
  ctx.restore();

  return out;
}






function drawSurfacePlacement(ctx, designImg, placement) {
  const canvas = ctx.canvas;
  const r   = placement.rect || {};
  const box = placement.box  || {};
  const d   = placement.design || {};

  // Box styling (appliceras på hela "ytan")
  const pad    = Number(box.padding || 0);
  const radius = Number(box.borderRadius || 0);
  const bg     = (box.backgroundColor == null ? "transparent" : box.backgroundColor);

  const bw     = Number(box.borderWidth || 0);
  const bc     = box.borderColor || "#000";

  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  // Tillgänglig area (w/h eller maxWidth/maxHeight)
  const refW = (typeof r.w === 'number' && r.w > 0) ? r.w :
               (typeof r.width === 'number' && r.width > 0) ? r.width :
               (typeof r.maxWidth === 'number' && r.maxWidth > 0) ? r.maxWidth : canvas.width;

  const refH = (typeof r.h === 'number' && r.h > 0) ? r.h :
               (typeof r.height === 'number' && r.height > 0) ? r.height :
               (typeof r.maxHeight === 'number' && r.maxHeight > 0) ? r.maxHeight : canvas.height;

  // Inre area för motivet
  const innerMaxW = Math.max(1, refW - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));
  const innerMaxH = Math.max(1, refH - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));

  // Skala motivet "contain"
  const srcW = designImg.width, srcH = designImg.height;
  const sx = innerMaxW / srcW, sy = innerMaxH / srcH;
  let s = Math.min(sx, sy);
  if (d && d.allowUpscale === false) s = Math.min(1, s);

  const drawW = Math.max(1, Math.round(srcW * s));
  const drawH = Math.max(1, Math.round(srcH * s));

  // Yttre boxstorlek (inkl. padding + ev. border)
  const boxW = drawW + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);
  const boxH = drawH + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);

  // Placering – center via cx/cy eller auto-center
  let cx, cy;
  if (typeof r.cx === 'number') cx = r.cx; else if (typeof r.x === 'number') cx = r.x + boxW/2; else cx = Math.round(canvas.width / 2);
  if (typeof r.cy === 'number') cy = r.cy; else if (typeof r.y === 'number') cy = r.y + boxH/2; else cy = Math.round(canvas.height / 2);

  const bx = Math.round(cx - boxW / 2);
  const by = Math.round(cy - boxH / 2);

  // Transform: skew + rotation
  const rotDeg = Number(d.rotate != null ? d.rotate : (d.rotate_deg != null ? d.rotate_deg : 0));
  const rotRad = rotDeg * Math.PI / 180;

  const shear   = d.shear || placement.shear || {};
  const shearX  = Number(shear.x || 0); // tangens-värde (t.ex. 0.06 ≈ ~3.4°)
  const shearY  = Number(shear.y || 0);

  // Blend/opacity för motivet
  const blendMode  = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  const blendAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;

  // Rita i transformerad kontext
  ctx.save();
  ctx.translate(cx, cy);
  // först skew (affin), sedan rotation
  ctx.transform(1, shearY, shearX, 1, 0, 0);
  ctx.rotate(rotRad);
  ctx.translate(-cx, -cy);

  // 1) Bakgrund (optional)
  if (bg && bg !== "transparent") {
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.fillStyle = bg;
    ctx.fill();
    ctx.restore();
  }

  // 2) Klipp till innerytan och rita motivet contain-centrerat
  const ix = bx + pad;
  const iy = by + pad;
  const tileW = Math.max(1, boxW - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));
  const tileH = Math.max(1, boxH - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));

  ctx.save();
  roundRectPath(ctx, ix, iy, tileW, tileH, radius);
  ctx.clip();

  const dx = ix + Math.round((tileW - drawW) / 2);
  const dy = iy + Math.round((tileH - drawH) / 2);

  // --- Bygg en roterad/klippt mask av själva motivet (inkl. PNG-alfa + rundade hörn) ---
  const motifMaskCanvas = document.createElement('canvas');
  motifMaskCanvas.width  = tileW;
  motifMaskCanvas.height = tileH;
  {
    const mctx = motifMaskCanvas.getContext('2d');
    // klipp till samma form som ytan
    roundRectPath(mctx, 0, 0, tileW, tileH, radius);
    mctx.clip();
    // rita motivet i tile-koordinater (samma dx/dy/drawW/drawH som huvudytan)
    mctx.drawImage(designImg, 0, 0, srcW, srcH, dx - ix, dy - iy, drawW, drawH);
  }

  // --- Skugga efter PNG-alfa (om begärt) ---
  const wantMotifShadow = !!(placement.placementOptions && placement.placementOptions.motifShadow);
  if (wantMotifShadow) {
    ctx.save();
    ctx.shadowColor   = shColor;
    ctx.shadowBlur    = shBlur;
    ctx.shadowOffsetX = shOX;
    ctx.shadowOffsetY = shOY;
    // skugga exakt enligt masken
    ctx.drawImage(motifMaskCanvas, ix, iy);
    ctx.restore();
  } else {
    // boxskugga
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.shadowColor   = shColor;
    ctx.shadowBlur    = shBlur;
    ctx.shadowOffsetX = shOX;
    ctx.shadowOffsetY = shOY;
    ctx.fillStyle = bg || "rgba(0,0,0,0)";
    ctx.fill();
    ctx.restore();
  }

  // Motiv (använd samma blend/alpha men dra från vår mask-canvas för identiskt resultat)
  ctx.globalCompositeOperation = blendMode;
  ctx.globalAlpha = blendAlpha;
  ctx.drawImage(motifMaskCanvas, ix, iy);

// === 4b) Laminat över motivet (följer PNG-alfa + rundade hörn) ===
const wantLaminate =
  placement.placementOptions &&
  placement.placementOptions.laminate === true;

if (wantLaminate && motifMaskCanvas) {
  const laminateAlpha =
    (typeof placement.placementOptions.laminateAlpha === "number")
      ? placement.placementOptions.laminateAlpha
      : 0.33;

  // Bygg laminat i box-koordinater (sam storlek som masken)
  const lam = document.createElement('canvas');
  lam.width = boxW;
  lam.height = boxH;
  const lctx = lam.getContext('2d');

  // Valfri enkel highlight/film—en vertikal gradering
  const gx = 0, gy = 0, gw = boxW, gh = boxH;
  const g = lctx.createLinearGradient(0, gy, 0, gy + gh);
  g.addColorStop(0.00, "rgba(255,255,255,0.22)");
  g.addColorStop(0.35, "rgba(255,255,255,0.10)");
  g.addColorStop(1.00, "rgba(255,255,255,0.00)");
  lctx.fillStyle = g;
  lctx.fillRect(gx, gy, gw, gh);

  // Maska laminatet med exakt samma mask som motivet
  lctx.globalCompositeOperation = "destination-in";
  lctx.drawImage(motifMaskCanvas, 0, 0);

  // Rita tillbaka över motivet, inuti samma box
  ctx.save();
  roundRectPath(ctx, bx, by, boxW, boxH, radius);
  ctx.clip();
  ctx.globalCompositeOperation = "screen";
  ctx.globalAlpha = laminateAlpha;
  ctx.drawImage(lam, bx, by);
  ctx.restore();
}


  // Avsluta inner-clip
  ctx.restore();

  // 3) Border runt ytan
  if (bw > 0) {
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.lineWidth = bw;
    ctx.strokeStyle = bc;
    ctx.shadowColor = "transparent";
    ctx.stroke();
    ctx.restore();
  }

  // Avsluta transform
  ctx.restore();
}


// === NYTT: Poster A1-placement (automatisk portrait/landscape, ingen rotation, cover i ramen) ===
// Placera motivet i en A1-ram som väljer proportion efter motivet (kvadratiskt → portrait).
function drawPosterA1Placement(ctx, designImg, placement) {
  const canvas = ctx.canvas;
  const r     = placement.rect  || {};
  const box   = placement.box   || {};
  const frame = placement.frame || {};

  // Box-styling (bakgrund, skugga, border, radius)
  const pad    = Number(box.padding || 0);
  const radius = Number(box.borderRadius || 0);
  const bg     = (box.backgroundColor == null ? "transparent" : box.backgroundColor);
  const bw     = Number(box.borderWidth || 0);
  const bc     = box.borderColor || "#000";

  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  // Frame (passepartout)
  const frameThickness = Math.max(0, Number(frame.thickness || 0));
  const frameColor     = (frame.color || "#ffffff");

  // A1-aspekter
  const A1_PORTRAIT_AR  = 594 / 841; // w/h ≈ 0.706
  const A1_LANDSCAPE_AR = 841 / 594; // w/h ≈ 1.416

  const imgW = designImg.width, imgH = designImg.height;
  const usePortrait = (imgH >= imgW); // kvadratiskt → portrait
  const targetAR = usePortrait ? A1_PORTRAIT_AR : A1_LANDSCAPE_AR;

  // Tillgängliga maxmått från rect
  const refW = (typeof r.w === 'number' && r.w > 0) ? r.w :
               (typeof r.width === 'number' && r.width > 0) ? r.width :
               (typeof r.maxWidth === 'number' && r.maxWidth > 0) ? r.maxWidth : canvas.width;

  const refH = (typeof r.h === 'number' && r.h > 0) ? r.h :
               (typeof r.height === 'number' && r.height > 0) ? r.height :
               (typeof r.maxHeight === 'number' && r.maxHeight > 0) ? r.maxHeight : canvas.height;

  // Yttre "poster"-yta (ramens utsida) – passa in targetAR
  const innerMaxW = Math.max(1, refW - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));
  const innerMaxH = Math.max(1, refH - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));

  let posterW = innerMaxW;
  let posterH = Math.round(posterW / targetAR);
  if (posterH > innerMaxH) {
    posterH = innerMaxH;
    posterW = Math.round(posterH * targetAR);
  }

  // Boxens yttre storlek (inkl. padding/border)
  let boxW = posterW + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);
  let boxH = posterH + pad*2 + (bw > 0 ? Math.ceil(bw) : 0);

  // 🔸 Min/max-clamp på boxen
  const minBoxW = Number(r.minBoxWidth  || 0);
  const maxBoxW = Number(r.maxBoxWidth  || 0);
  const maxBoxH = Number(r.maxBoxHeight || 0);

  // Enforce min-bredd endast i landscape-läge
  if (!usePortrait && minBoxW > 0 && boxW < minBoxW) {
    const s = minBoxW / boxW;
    posterW = Math.round(posterW * s);
    posterH = Math.round(posterH * s);
    boxW    = Math.round(boxW * s);
    boxH    = Math.round(boxH * s);
  }

  // Respektera max-gränser om satta
  if ((maxBoxW > 0 && boxW > maxBoxW) || (maxBoxH > 0 && boxH > maxBoxH)) {
    const sx = (maxBoxW > 0) ? maxBoxW / boxW : 1;
    const sy = (maxBoxH > 0) ? maxBoxH / boxH : 1;
    const s  = Math.min(sx, sy);
    posterW = Math.round(posterW * s);
    posterH = Math.round(posterH * s);
    boxW    = Math.round(boxW * s);
    boxH    = Math.round(boxH * s);
  }

// EFTER
// Placering av boxen (center default) + stöd för topOffset (överkanten av POSTER-BOXEN vid exakt Y)
let bx, by;

// X-placering
if (r.center === true || r.x === 'center') {
  bx = Math.round((canvas.width - boxW) / 2);
} else {
  const boundsW = Math.max(1, Number(r.w || r.width || canvas.width));
  bx = (typeof r.x === 'number') ? r.x : Math.round((canvas.width - boundsW) / 2);
  if (typeof r.cx === 'number') bx = Math.round(r.cx - boxW / 2);
}

// Y-placering (default)
if (r.center === true || r.y === 'center') {
  by = Math.round((canvas.height - boxH) / 2);
} else {
  const boundsH = Math.max(1, Number(r.h || r.height || canvas.height));
  by = (typeof r.y === 'number') ? r.y : Math.round((canvas.height - boundsH) / 2);
  if (typeof r.cy === 'number') by = Math.round(r.cy - boxH / 2);
}

// 🔸 topOffset: lås posterns Y-topp (boxens utsida) till exakt pixel
if (typeof r.topOffset === 'number' && isFinite(r.topOffset)) {
  by = Math.round(r.topOffset - pad); // pad=0 i din config → by = topOffset
}



// Rita box-bakgrund + skugga (fungerar även med transparent bg)
ctx.save();
roundRectPath(ctx, bx, by, boxW, boxH, radius);

// rita en temporär fylld form för att bära skuggan
ctx.shadowColor   = shColor;
ctx.shadowBlur    = shBlur;
ctx.shadowOffsetX = shOX;
ctx.shadowOffsetY = shOY;
ctx.fillStyle = "#000";
ctx.fill();

// slå sedan ut fyllningen så bara skuggan återstår
ctx.globalCompositeOperation = "destination-out";
ctx.shadowColor = "transparent";
ctx.shadowBlur = 0; ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0;
ctx.fillStyle = "#000";
ctx.fill();
ctx.restore();


  // Boxens inner-rektangel
  const ix = bx + pad;
  const iy = by + pad;

  // Rita posterns "frame" (passepartout) som fylld rektangel
  ctx.save();
  roundRectPath(ctx, ix, iy, posterW, posterH, radius);
  ctx.clip();
  ctx.fillStyle = frameColor;
  ctx.fillRect(ix, iy, posterW, posterH);

  // Inre bildyta (innanför passepartout)
  const innerX = ix + frameThickness;
  const innerY = iy + frameThickness;
  const innerW = Math.max(1, posterW - frameThickness*2);
  const innerH = Math.max(1, posterH - frameThickness*2);

  // Clip till bildytan
  ctx.beginPath();
  roundRectPath(ctx, innerX, innerY, innerW, innerH, Math.max(0, radius - Math.min(radius, frameThickness)));
  ctx.clip();

  // Blend/opacity för motivet
  const blendMode  = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  const blendAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;

  // COVER-skalning (ingen rotation)
  const sCover = Math.max(innerW / imgW, innerH / imgH);
  const drawW  = Math.max(1, Math.round(imgW * sCover));
  const drawH  = Math.max(1, Math.round(imgH * sCover));
  const dx     = innerX + Math.round((innerW - drawW) / 2);
  const dy     = innerY + Math.round((innerH - drawH) / 2);

  ctx.globalCompositeOperation = blendMode;
  ctx.globalAlpha = blendAlpha;
  ctx.drawImage(designImg, 0, 0, imgW, imgH, dx, dy, drawW, drawH);
  ctx.restore();

  // Border på boxen (ytterkant)
  if (bw > 0) {
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.lineWidth = bw;
    ctx.strokeStyle = bc;
    ctx.shadowColor = "transparent";
    ctx.stroke();
    ctx.restore();
  }
}

// ✅ KEEP THIS ONE — DELETE the later duplicate version entirely
function drawBoxTileYPlacement(ctx, designImg, placement) {
  const canvas = ctx.canvas;
  const box = placement.box || {};
  const r   = placement.rect || {};

  const pad    = Number(box.padding || 0);
  const radius = Number(box.borderRadius || 0);
  const bg     = (box.backgroundColor == null ? "transparent" : box.backgroundColor);
  const bw     = Number(box.borderWidth || 0);
  const bc     = box.borderColor || "#000";

  const shColor = box.shadowColor || "transparent";
  const shBlur  = Number(box.shadowBlur || 0);
  const shOX    = Number(box.shadowOffsetX || 0);
  const shOY    = Number(box.shadowOffsetY || 0);

  const refW = Math.max(1, Number(r.w || r.width  || r.maxWidth  || canvas.width));
  const refH = Math.max(1, Number(r.h || r.height || r.maxHeight || canvas.height));

  let bx, by;
  if (r.center === true || r.x === 'center' || r.y === 'center') {
    bx = Math.round((canvas.width  - refW) / 2);
    by = Math.round((canvas.height - refH) / 2);
  } else {
    bx = (typeof r.x === 'number') ? r.x : Math.round((canvas.width  - refW) / 2);
    by = (typeof r.y === 'number') ? r.y : Math.round((canvas.height - refH) / 2);
    if (typeof r.cx === 'number') bx = Math.round(r.cx - refW / 2);
    if (typeof r.cy === 'number') by = Math.round(r.cy - refH / 2);
  }

  const boxW = refW, boxH = refH;

  // Background + shadow
  ctx.save();
  roundRectPath(ctx, bx, by, boxW, boxH, radius);
  ctx.shadowColor   = shColor;
  ctx.shadowBlur    = shBlur;
  ctx.shadowOffsetX = shOX;
  ctx.shadowOffsetY = shOY;
  ctx.fillStyle = (bg && bg !== "transparent") ? bg : "rgba(0,0,0,0)";
  ctx.fill();
  ctx.restore();

  // Tile scaling (horizontal contain)
  const innerMaxW = Math.max(1, boxW - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));
  const innerMaxH = Math.max(1, boxH - pad*2 - (bw > 0 ? Math.ceil(bw) : 0));
  const allowUpscale = !(placement.design && placement.design.allowUpscale === false);

  const srcW = designImg.width, srcH = designImg.height;
  let scale = innerMaxW / srcW;
  if (!allowUpscale) scale = Math.min(1, scale);

  const tileW = Math.max(1, Math.round(srcW * scale));
  const tileH = Math.max(1, Math.round(srcH * scale));

  const ix = bx + pad;
  const iy = by + pad;
   const innerH = innerMaxH;

  ctx.save();
  roundRectPath(ctx, bx, by, boxW, boxH, radius);
  ctx.clip();

  const blendMode  = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
  const blendAlpha = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;
  ctx.globalCompositeOperation = blendMode;
  ctx.globalAlpha = blendAlpha;

  // Nytt: rita ett fast antal upprepningar (default 2 → identiskt med nuvarande beteende)
  const repeats = Math.max(1, Number(placement.repeatCount || 2));
  let y = 0;
  for (let i = 0; i < repeats; i++) {
    ctx.drawImage(designImg, 0, 0, srcW, srcH, ix, iy + y, tileW, tileH);
    y += tileH; // avsiktligt ingen gapY här (nuvarande kod ignorerar gapY → ändrar inte utseendet)
  }
  ctx.restore();

  if (bw > 0) {
    ctx.save();
    roundRectPath(ctx, bx, by, boxW, boxH, radius);
    ctx.lineWidth = bw;
    ctx.strokeStyle = bc;
    ctx.shadowColor = "transparent";
    ctx.stroke();
    ctx.restore();
  }
}






   // ===== Placements-loop =====
   // ===== Placements-loop =====
let __firstSingleTransform = null; // { rot90, drawW, drawH, dx_ratio, dy_ratio }
const __boxRects = [];

// ⬇️ NYTT: kontroll + helper för att rita secondbase exakt en gång
let __secondBaseDrawn = false;
async function __drawSecondBaseOnce() {
  if (__secondBaseDrawn) return;
  if (!(item.secondbase && item.secondbase.length)) { __secondBaseDrawn = true; return; }

  for (const sbConfig of item.secondbase) {
    if (!sbConfig.url) continue;

    const secondBaseSrc = resolveSrc(sbConfig, cloudName);
    const secondBaseImg = await __load(secondBaseSrc);
    if (!secondBaseImg) continue;

    const blendMode = sbConfig.mode || "normal";
    const opacity   = (typeof sbConfig.opacity === "number") ? sbConfig.opacity : 1.0;
    const passes    = Math.max(1, parseInt(sbConfig.passes || 1, 10));
    const rect      = sbConfig.rect || {};
    const fit       = (rect.fit || "contain").toLowerCase();

    const targetW = rect.w || canvas.width;
    const targetH = rect.h || canvas.height;

    const imgRatio = secondBaseImg.width / secondBaseImg.height;
    const boxRatio = targetW / targetH;

    let drawW, drawH;
    if (fit === "cover") {
      if (imgRatio > boxRatio) {
        drawH = targetH;
        drawW = drawH * imgRatio;
      } else {
        drawW = targetW;
        drawH = drawW / imgRatio;
      }
    } else {
      if (imgRatio > boxRatio) {
        drawW = targetW;
        drawH = drawW / imgRatio;
      } else {
        drawH = targetH;
        drawW = drawH * imgRatio;
      }
    }

    let dx, dy;
    if (typeof rect.cx === "number" && typeof rect.cy === "number") {
      dx = Math.round(rect.cx - drawW / 2);
      dy = Math.round(rect.cy - drawH / 2);
    } else {
      dx = typeof rect.x === "number" ? rect.x : 0;
      dy = typeof rect.y === "number" ? rect.y : 0;
    }

    for (let p = 0; p < passes; p++) {
      ctx.save();
      ctx.globalCompositeOperation = blendMode;
      ctx.globalAlpha = opacity;
      ctx.drawImage(secondBaseImg, dx, dy, drawW, drawH);
      ctx.restore();
    }
  }

  __secondBaseDrawn = true;
}

for (let __pi = 0; __pi < placements.length; __pi++) {
  const placement = placements[__pi];
  const type = placement.type || "single";

if (type === "box") {
  const area = { x: 0, y: 0, width: canvas.width, height: canvas.height };

  // behåll ”gamla” fallbacken för vissa slugs …
  const slug = String(item.slug || "");
  const enableMotifShadowAndMin =
    slug === "konturskurna-klistermarken" ||
    slug === "klistermarken-med-runda-horn" ||
    slug === "holografiska-stickers" ||
    slug === "kiss-cut-klistermarken";

  // … men låt placementOptions ALLTID vinna
  const wantMotifShadow = (placement.placementOptions && placement.placementOptions.motifShadow) != null
    ? !!placement.placementOptions.motifShadow
    : enableMotifShadowAndMin;

  const wantEnableMinRect = (placement.placementOptions && placement.placementOptions.enableMinRect) != null
    ? !!placement.placementOptions.enableMinRect
    : enableMotifShadowAndMin;

  const __metrics = drawBoxPlacement(ctx, designImg, area, placement, {
    motifShadow:   wantMotifShadow,
    enableMinRect: wantEnableMinRect
  });
  if (__metrics) __boxRects.push({ ...__metrics, placement });
  continue;
}

if (type === "smartCard") {
  drawSmartCardPlacement(ctx, designImg, placement);
  continue;
}
if (type === "surface" || type === "laptopSurface") {
  drawSurfacePlacement(ctx, designImg, placement);
  continue;
}
if (type === "posterA1") {
  drawPosterA1Placement(ctx, designImg, placement);
  continue;
}



      if (type === "boxTileY") {
        drawBoxTileYPlacement(ctx, designImg, placement);
        continue;
      }


if (type === "rollTwoY") {
  const m = drawRollTwoYPlacement(ctx, designImg, placement);
  if (m && m.length) __boxRects.push(...m);

  // ⬅️ RITA SECONDBASE DIREKT EFTER RULLEN (ovanpå rullen men före nästa placement)
  await __drawSecondBaseOnce();
  continue;
}



      const dispSrc = resolveSrc(placement.mask_url || placement.mask_public_id, cloudName);
      const maskImg = dispSrc ? await __load(dispSrc) : null;

      const blendMode = (placement.blend && placement.blend.mode) ? placement.blend.mode : "source-over";
      const blendOpacity = (placement.blend && typeof placement.blend.opacity === "number") ? placement.blend.opacity : 1.0;

      if (type === "single") {
        // Area = mask-bbox, fallback -> rect
        let area, mCtx = null;
        if (maskImg) {
          const bb = bboxFromMask(maskImg);
          area = { x: bb.x, y: bb.y, width: bb.width, height: bb.height };
          mCtx = bb.mCtx;
        } else {
          const r = placement.rect || { x: 0, y: 0, w: canvas.width, h: canvas.height };
          area = { x: r.x, y: r.y, width: r.w, height: r.h };
        }

        // AUTO-REPEAT (opt-in)
        if (placement.autoRepeat) {
          let maskData = null;
          if (maskImg && mCtx) {
            maskData = mCtx.getImageData(area.x, area.y, area.width, area.height);
          }

          const imgW = designImg.width, imgH = designImg.height;
          const ar = placement.autoRepeat;

          const targetW = (ar.tile_px && ar.tile_px.w) ? ar.tile_px.w : null;
          const targetH = (ar.tile_px && ar.tile_px.h) ? ar.tile_px.h : null;

          let sW = targetW ? (targetW / imgW) : null;
          let sH = targetH ? (targetH / imgH) : null;

          let s;
          if (sW && sH)      s = Math.min(sW, sH);
          else if (sW)       s = sW;
          else if (sH)       s = sH;
          else               s = 1.0;

          let tileW = Math.max(1, Math.round(imgW * s));
          let tileH = Math.max(1, Math.round(imgH * s));

          const rotate90 =
            (ar.rotate === 90) ||
            (ar.rotate_if_landscape === true && (imgW > imgH)) ||
            (ar.rotate_if_landscape_in_portrait === true && (area.height > area.width) && (imgW > imgH));

          if (ar.min_repeats && ar.min_repeats.axis) {
            if (ar.min_repeats.axis === "x") {
              const maxTileW = Math.floor(area.width / Math.max(1, ar.min_repeats.count));
              if (tileW > maxTileW) {
                const adjS = maxTileW / imgW;
                tileW = Math.max(1, Math.round(imgW * adjS));
                tileH = Math.max(1, Math.round(imgH * adjS));
              }
            } else if (ar.min_repeats.axis === "y") {
              const maxTileH = Math.floor(area.height / Math.max(1, ar.min_repeats.count));
              if (tileH > maxTileH) {
                const adjS = maxTileH / imgH;
                tileW = Math.max(1, Math.round(imgW * adjS));
                tileH = Math.max(1, Math.round(imgH * adjS));
              }
            }
          }

          // Perfekt passning: en ENDA tegel får exakt samma höjd som area och (efter skala) samma bredd som area
// (vi jobbar i “höjd-normaliserat” läge, identiskt med hur single-ritningen görs)
const pxTol = (typeof ar.pixel_tolerance === "number") ? Math.max(0, ar.pixel_tolerance) : 1; // tillåt ±1 px

// bas-tegel efter ev. 90° (vi räknade redan tileW/tileH ovan utifrån target px)
const baseW = rotate90 ? tileH : tileW;
const baseH = rotate90 ? tileW : tileH;

// sträck teglens höjd till exakt area-höjd (samma princip som i single-rendern)
const scaleY   = baseH > 0 ? (area.height / baseH) : 1;
const finalW   = Math.round(baseW * scaleY);
const finalH   = Math.round(baseH * scaleY); // = area.height

// “Perfekt” betyder: finalH == area.height och finalW == area.width (inom pxTol)
const heightOK = Math.abs(finalH - area.height) <= pxTol;
const widthOK  = Math.abs(finalW - area.width)  <= pxTol;
const perfectFit = heightOK && widthOK;

if (perfectFit && !ar.force_repeat) {
  // --- SINGLE (identiskt som tidigare, men triggas nu ENDAST vid perfekt passning) ---
  const temp = document.createElement('canvas');
  temp.width = area.width;
  temp.height = area.height;
  const tctx = temp.getContext('2d');

  if (rotate90) {
    tctx.translate(area.width / 2, area.height / 2);
    tctx.rotate(Math.PI / 2);
    tctx.drawImage(designImg, -finalH / 2, -finalW / 2, finalH, finalW);
  } else {
    const dxCenter = Math.round((area.width  - finalW) / 2);
    const dyCenter = Math.round((area.height - finalH) / 2);
    tctx.drawImage(designImg, dxCenter, dyCenter, finalW, finalH);
  }

  if (maskData) {
    const td = tctx.getImageData(0, 0, area.width, area.height);
    for (let j = 0; j < maskData.data.length; j += 4) {
      td.data[j + 3] = Math.round(td.data[j + 3] * (maskData.data[j] / 255));
    }
    tctx.putImageData(td, 0, 0);
  }

  ctx.save();
  ctx.globalCompositeOperation = blendMode;
  ctx.globalAlpha = blendOpacity;
  ctx.drawImage(temp, area.x, area.y);
  ctx.restore();
} else {
  // --- REPEAT som vanligt ---
  ctx.save();
  ctx.globalCompositeOperation = blendMode;
  ctx.globalAlpha = blendOpacity;
  drawRepeatedDesignIntoArea(ctx, designImg, area, maskData, {
    rotate90,
    tileW,
    tileH
  });
  ctx.restore();
}

          continue; // hoppa över standard single-flow

        }

        // ========= SINGLE: lås transform från första ytan =========
        const imgW = designImg.width, imgH = designImg.height;
        const dcfg = placement.design || {};
        const fit = (String(dcfg.fit).toLowerCase() === "contain") ? "contain" : "cover";

        const __syncAllSingles = !!(item.syncSinglePlacements);
        const __inherit = (placement.inherit_transform_from === "first");
        const __shouldInherit = (__inherit || __syncAllSingles) && __firstSingleTransform !== null && __pi > 0;

        let rot90 = __shouldInherit
          ? __firstSingleTransform.rot90
          : (
              (dcfg.rotate === 90) ||
              (dcfg.rotate_if_landscape === true && imgW > imgH) ||
              (dcfg.rotate_if_landscape_in_portrait === true && area.height > area.width && imgW > imgH)
            );

        let src = designImg;
        let srcW = imgW, srcH = imgH;
        if (rot90) {
          const rc = document.createElement('canvas');
          rc.width  = imgH;
          rc.height = imgW;
          const rctx = rc.getContext('2d');
          rctx.translate(rc.width / 2, rc.height / 2);
          rctx.rotate(Math.PI / 2);
          rctx.drawImage(designImg, -imgW / 2, -imgH / 2);
          rctx.setTransform(1, 0, 0, 1, 0, 0);
          src = rc; srcW = rc.width; srcH = rc.height;
        }

        let drawW, drawH, dx, dy;

        if (__shouldInherit) {
          drawW = __firstSingleTransform.drawW;
          drawH = __firstSingleTransform.drawH;
          dx = Math.round(area.width  * __firstSingleTransform.dx_ratio);
          dy = Math.round(area.height * __firstSingleTransform.dy_ratio);
        } else {
          const s_fit = (fit === "contain")
            ? Math.min(area.width / srcW, area.height / srcH)
            : Math.max(area.width / srcW, area.height / srcH);

          drawW = Math.ceil(srcW * s_fit);
          drawH = Math.ceil(srcH * s_fit);

          dx = Math.round((area.width  - drawW) / 2);
          dy = Math.round((area.height - drawH) / 2);

          __firstSingleTransform = {
            rot90,
            drawW,
            drawH,
            dx_ratio: area.width  ? (dx / area.width)  : 0,
            dy_ratio: area.height ? (dy / area.height) : 0
          };
        }

        const temp = document.createElement('canvas');
        temp.width = area.width;
        temp.height = area.height;
        const tctx = temp.getContext('2d');
        tctx.drawImage(src, 0, 0, srcW, srcH, dx, dy, drawW, drawH);

        if (maskImg && mCtx) {
          const maskData = mCtx.getImageData(area.x, area.y, area.width, area.height);
          const td = tctx.getImageData(0, 0, area.width, area.height);
          for (let j = 0; j < maskData.data.length; j += 4) {
            const a = maskData.data[j];
            td.data[j + 3] = Math.round(td.data[j + 3] * (a / 255));
          }
          tctx.putImageData(td, 0, 0);
        }

        ctx.save();
        ctx.globalCompositeOperation = blendMode;
        ctx.globalAlpha = blendOpacity;
        ctx.drawImage(temp, area.x, area.y);
        ctx.restore();

      } else if (type === "tiled") {
        const bounds = placement.bounds || { x: 0, y: 0, w: canvas.width, h: canvas.height };
        const gapX = (placement.pattern && typeof placement.pattern.gap_x === "number") ? placement.pattern.gap_x : 0;

        const s = Math.max(bounds.h / designImg.height, bounds.w / designImg.width);
        const tileW = Math.ceil(designImg.width * s);
        const tileH = Math.ceil(designImg.height * s);
        const yOffset = bounds.y + Math.round((bounds.h - tileH) / 2);

        let maskData = null;
        if (maskImg) {
          const mCanvas = document.createElement('canvas');
          mCanvas.width = canvas.width;
          mCanvas.height = canvas.height;
          const mCtx = mCanvas.getContext('2d');
          mCtx.drawImage(maskImg, 0, 0, canvas.width, canvas.height);
          maskData = mCtx.getImageData(bounds.x, bounds.y, bounds.w, bounds.h);
        }

        let x = bounds.x;
        while (x < bounds.x + bounds.w) {
          const temp = document.createElement('canvas');
          temp.width = bounds.w;
          temp.height = bounds.h;
          const tctx = temp.getContext('2d');

          tctx.drawImage(
            designImg,
            0, 0, designImg.width, designImg.height,
            Math.round((bounds.w - tileW) / 2), Math.round((bounds.h - tileH) / 2),
            tileW, tileH
          );

          if (maskData) {
            const td = tctx.getImageData(0, 0, bounds.w, bounds.h);
            for (let j = 0; j < maskData.data.length; j += 4) {
              const a = maskData.data[j];
              td.data[j + 3] = Math.round(td.data[j + 3] * (a / 255));
            }
            tctx.putImageData(td, 0, 0);
          }

          ctx.save();
          ctx.globalCompositeOperation = blendMode;
          ctx.globalAlpha = blendOpacity;
          ctx.drawImage(temp, x, yOffset);
          ctx.restore();

          x += tileW + gapX;
        }
      } else {
        console.warn("renderFromTemplate: okänt placement.type =", type, "i item id:", item.id);
      }
    }

 // --- Skuggor (oförändrat) ---
if (shadowsSrc) {
  const shadowImg = await __load(shadowsSrc);
  if (shadowImg) {
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    ctx.globalAlpha = shadowOpacity;
    ctx.drawImage(shadowImg, 0, 0, canvas.width, canvas.height);
    ctx.restore();
  }
}

if (Array.isArray(__boxRects) && __boxRects.length) {
  for (const r of __boxRects) {
    const { bx, by, motifMaskCanvas, placement, transform } = r;
    const cfg = placement && placement.printAreaBorder;
    if (!motifMaskCanvas || !cfg || cfg.enabled !== true) continue;

    ctx.save();
    if (transform && typeof transform.rotateDeg === "number" && transform.rotateDeg !== 0) {
      const rad = transform.rotateDeg * Math.PI / 180;
      ctx.translate(transform.cx, transform.cy);
      ctx.rotate(rad);
      ctx.translate(-transform.cx, -transform.cy);
    }
    drawAlphaBorderFromImage(ctx, motifMaskCanvas, bx, by, {
      color:   cfg.color   ?? "#ccc",
      blur:    Number(cfg.blur ?? 4),
      offsetX: Number(cfg.offsetX ?? 0),
      offsetY: Number(cfg.offsetY ?? 2),
      opacity: (typeof cfg.opacity === "number" ? cfg.opacity : 1),
      width:   Number(cfg.width ?? 0)
    });
    ctx.restore();
  }
}
// === SECOND BASE OVERLAY (JSON-styrd + fit contain/cover) — flyttad att ritas direkt efter rollTwoY ===
await __drawSecondBaseOnce();





if (highlightOverlay) {
  const highlightImg = await __load(highlightOverlay);
  if (highlightImg) {
    const hlConfig = item.highlights[0] || {};
    const blendMode = hlConfig.mode || "screen";
    const opacity   = (typeof hlConfig.opacity === "number") ? hlConfig.opacity : 1.0;
    const passes    = Math.max(1, parseInt(hlConfig.passes || 1, 10));

    const drawWholeCanvas = async () => {
      for (let p = 0; p < passes; p++) {
        ctx.save();
        ctx.globalCompositeOperation = blendMode;
        ctx.globalAlpha = opacity;
        ctx.drawImage(highlightImg, 0, 0, canvas.width, canvas.height);
        ctx.restore();
      }
    };

    if (Array.isArray(__boxRects) && __boxRects.length) {
      for (const r of __boxRects) {
        const { bx, by, boxW, boxH, radius, motifMaskCanvas, transform } = r;
        if (!motifMaskCanvas) continue;

        const hiW = highlightImg.width, hiH = highlightImg.height;
        const s   = Math.max(boxW / hiW, boxH / hiH);
        const drawW = Math.max(1, Math.round(hiW * s));
        const drawH = Math.max(1, Math.round(hiH * s));
        const dx = Math.round((boxW - drawW) / 2);
        const dy = Math.round((boxH - drawH) / 2);

        const makeTile = () => {
          const hlTile = document.createElement('canvas');
          hlTile.width = boxW;
          hlTile.height = boxH;
          const hctx = hlTile.getContext('2d');
          hctx.drawImage(highlightImg, 0, 0, hiW, hiH, dx, dy, drawW, drawH);
          hctx.globalCompositeOperation = "destination-in";
          hctx.drawImage(motifMaskCanvas, 0, 0);
          return hlTile;
        };

        const hlTile = makeTile();
        for (let p = 0; p < passes; p++) {
          ctx.save();
          if (transform && typeof transform.rotateDeg === "number" && transform.rotateDeg !== 0) {
            const rad = transform.rotateDeg * Math.PI / 180;
            ctx.translate(transform.cx, transform.cy);
            ctx.rotate(rad);
            ctx.translate(-transform.cx, -transform.cy);
          }
          roundRectPath(ctx, bx, by, boxW, boxH, radius);
          ctx.clip();
          ctx.globalCompositeOperation = blendMode;
          ctx.globalAlpha = opacity;
          ctx.drawImage(hlTile, bx, by);
          ctx.restore();
        }
      }
    } else {
      await drawWholeCanvas();
    }
  }
}





}

  // ======== Cloudinary-upload (påverkar ej renderlogik) ========
  function saveMockupToCloudinary(projectId, extraFields = {}, canvasId = "mockup-canvas") {
    return new Promise((resolve, reject) => {
      try {
        const canvas = document.getElementById(canvasId);
        if (!canvas) return reject(new Error("MockupEngine: Kunde inte hitta canvas för Cloudinary-upload."));
        const dataUrl = canvas.toDataURL("image/png");
        var formData = new FormData();
        formData.append('file', dataUrl);
        formData.append('upload_preset', 'pitchprint_unsigned');
        fetch('https://api.cloudinary.com/v1_1/dmgmoisae/image/upload', {
          method: 'POST',
          body: formData
        })
        .then(r => r.json())
        .then(json => {
          if (!json.secure_url) throw new Error("Cloudinary upload misslyckades: " + (json.error && json.error.message));
          const storedProjects = JSON.parse(localStorage.getItem("pitchprint_project_map") || '{}');
          storedProjects[projectId] = storedProjects[projectId] || {};
          storedProjects[projectId].mockup = json.secure_url;
           if (extraFields && typeof extraFields === 'object') {
            Object.assign(storedProjects[projectId], extraFields);
          }
          localStorage.setItem("pitchprint_project_map", JSON.stringify(storedProjects));
          resolve(json.secure_url);
        })
        .catch(err => {
          console.error("MockupEngine: Kunde inte ladda upp/spara mockup till Cloudinary:", err);
          reject(err);
        });
      } catch (e) {
        console.error("MockupEngine: saveMockupToCloudinary error:", e);
        reject(e);
      }
    });
  }

  // ====== API ======
  return {
    render,
    renderFromTemplate,
    saveMockupToCloudinary
  };
})();
